export default [
  {
    path: "/apps/calendar",
    name: "apps-calendar",
    component: () => import("@/views/apps/calendar/Calendar.vue"),
  },

  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: "/apps/email",
    name: "apps-email",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
    },
  },
  {
    path: "/apps/email/:folder",
    name: "apps-email-folder",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    beforeEnter(to, _, next) {
      if (
        ["sent", "draft", "starred", "spam", "trash"].includes(to.params.folder)
      )
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/apps/email/label/:label",
    name: "apps-email-label",
    component: () => import("@/views/apps/email/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    beforeEnter(to, _, next) {
      if (
        ["personal", "company", "important", "private"].includes(
          to.params.label
        )
      )
        next();
      else next({ name: "error-404" });
    },
  },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/todo",
    name: "apps-todo",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
    },
  },
  {
    path: "/apps/todo/:filter",
    name: "apps-todo-filter",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
      navActiveLink: "apps-todo",
    },
    beforeEnter(to, _, next) {
      if (["important", "completed", "deleted"].includes(to.params.filter))
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/apps/todo/tag/:tag",
    name: "apps-todo-tag",
    component: () => import("@/views/apps/todo/Todo.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "todo-application",
      navActiveLink: "apps-todo",
    },
    beforeEnter(to, _, next) {
      if (["team", "low", "medium", "high", "update"].includes(to.params.tag))
        next();
      else next({ name: "error-404" });
    },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/chats/:userId/:mainFlatId",
    name: "apps-chats",
    component: () => import("@/views/apps/chat/Chats.vue"),
    title: "چت ها",
    meta: {
      resource: "Support",
      action: "Support",
      pageTitle: "چت ها",
      // breadcrumb: [
      //   {
      //     text: 'لیست',
      //     active: true
      //   },
      // ],
    },
  },
  {
    path: "/apps/categories/virtual/list",
    name: "apps-categories-virtual-list",
    component: () => import("@/views/apps/categories/virtual/list.vue"),
  },
  {
    path: "/apps/categories/physical/list",
    name: "apps-categories-physical-list",
    component: () => import("@/views/apps/categories/physical/list.vue"),
  },
  {
    path: "/apps/plans/create",
    name: "apps-plans-create",
    component: () => import("@/views/apps/plans/PlanCreate.vue"),
  },
  {
    path: "/apps/plans/list",
    name: "apps-plans-list",
    component: () => import("@/views/apps/plans/PlanList.vue"),
  },
  {
    path: "/apps/plans/:id",
    name: "apps-plans-edit",
    component: () => import("@/views/apps/plans/PlanEdit.vue"),
  },
  {
    path: "/apps/ads/list",
    name: "apps-ads-list",
    component: () => import("@/views/apps/ads/AdsList.vue"),
  },
  {
    path: "/apps/tickets/list",
    name: "apps-tickets-list",
    component: () => import("@/views/apps/tickets/TicketList.vue"),
  },
  {
    path: "/apps/tickets/:id",
    name: "apps-tickets-detail",
    component: () => import("@/views/apps/tickets/SingleTicket.vue"),
  },
  {
    path: "/apps/ads/:slug/:id",
    name: "apps-ads-edit",
    component: () => import("@/views/apps/ads/AdEdit.vue"),
  },
  {
    path: "/apps/categories/guilds/list",
    name: "apps-categories-guilds-list",
    component: () => import("@/views/apps/categories/physical/guilds.vue"),
  },
  {
    path: "/apps/categories/physical/:id",
    name: "apps-categories-physical-editAPhysicalCategory",
    component: () =>
      import("@/views/apps/categories/physical/editAPhysicalCategory.vue"),
  },
  {
    path: "/apps/reports/list",
    name: "apps-reports-reports-list",
    component: () => import("@/views/apps/reports/ReportsList.vue"),
  },
  {
    path: "/apps/chat/:id/:mainFlatId",
    name: "apps-chats-id",
    resource: "Support",
    action: "Support",
    component: () => import("@/views/apps/chat/Chat.vue"),
    meta: {
      // contentRenderer: 'sidebar-left',
      contentClass: "chat-application",
    },
  },

  {
    path: "/apps/buy/:id",
    name: "apps-buy-id",
    component: () => import("@/views/apps/buy/Buy.vue"),
    meta: {
      pageTitle: "ثبت سفارش کاربر",
    },
  },

  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/e-commerce/students",
    name: "apps-e-commerce-students",
    component: () =>
      import("@/views/apps/e-commerce/students/StudentsList.vue"),
    // meta: {
    //   pageTitle: 'دانشجویان',
    // },
  },
  {
    path: "/apps/e-commerce/studentInfoes/:id",
    name: "apps-e-commerce-studentInfoes",
    component: () =>
      import("@/views/apps/e-commerce/students/StudentInfoes.vue"),
  },
  {
    path: "/apps/e-commerce/shop",
    name: "apps-e-commerce-shop",
    component: () =>
      import("@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue"),
    meta: {
      contentRenderer: "sidebar-left-detached",
      contentClass: "ecommerce-application",
      // pageTitle: 'محصولات',
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'لیست',
      //     active: true
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/add",
    name: "apps-e-commerce-add",
    component: () =>
      import("@/views/apps/e-commerce/e-commerce-add/ECommerceAdd.vue"),
    meta: {
      contentClass: "ecommerce-application",
      // pageTitle: 'محصولات',
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'افزودن محصول',
      //     active: true
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/add-course",
    name: "apps-e-commerce-add-course",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-add-course/ECommerceAddCourse"
      ),
    meta: {
      contentClass: "ecommerce-application",
      // pageTitle: 'محصولات',
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'افزودن دوره',
      //     active: true
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/add-product-media/:id",
    name: "apps-e-commerce-add-product-media",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-add-product-media/ECommerceAddProductMedia.vue"
      ),
    meta: {
      contentClass: "ecommerce-application",
      // pageTitle: 'محصولات',
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'افزودن مدیا',
      //     active: true
      //   },
      // ],
    },
  },
  // {
  //   path: '/apps/e-commerce/wishlist',
  //   name: 'apps-e-commerce-wishlist',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
  //   meta: {
  //     pageTitle: 'Wishlist',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Wishlist',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: "/apps/e-commerce/checkout",
    name: "apps-e-commerce-checkout",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue"
      ),
    meta: {
      pageTitle: "Checkout",
      contentClass: "ecommerce-application",
      breadcrumb: [
        {
          text: "ECommerce",
        },
        {
          text: "Checkout",
          active: true,
        },
      ],
    },
  },
  {
    path: "/apps/e-commerce/courses",
    name: "apps-e-commerce-courses",
    component: () => import("@/views/apps/e-commerce/courses/CoursesList.vue"),
    meta: {
      // pageTitle: 'دوره ها',
      contentClass: "ecommerce-application",
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'محصولات',
      //   },
      //   {
      //     text: 'لیست دوره ها',
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/comments",
    name: "apps-e-commerce-comments",
    component: () => import("@/views/apps/e-commerce/comments/ProductComments"),
    meta: {
      // pageTitle: 'نظرات',
      contentClass: "ecommerce-application",
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'محصولات',
      //   },
      //   {
      //     text: 'لیست نظرات',
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/comments/:id",
    name: "apps-e-commerce-comments-edit",
    component: () =>
      import("@/views/apps/e-commerce/comments/ProductCommentEdit.vue"),
    meta: {
      // pageTitle: 'ویرایش',
      contentClass: "ecommerce-application",
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'محصولات',
      //   },
      //   {
      //     text: 'کامنت ها',
      //   },
      //   {
      //     text: 'ویرایش',
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/courses/edit/:id",
    name: "apps-e-commerce-courses-edit",
    component: () => import("@/views/apps/e-commerce/courses/CoursesEdit.vue"),
    meta: {
      // pageTitle: 'دوره ها',
      resource: "ProductManager",
      action: "ProductManager",
      contentClass: "ecommerce-application",
      // breadcrumb: [
      //   {
      //     text: 'محصولات',
      //   },
      //   {
      //     text: 'لیست دوره ها',
      //   },
      //   {
      //     text: 'ویرایش',
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: "/apps/e-commerce/courses/stream",
    name: "apps-e-commerce-courses-stream",
    component: () =>
      import("@/views/apps/e-commerce/courses/CourseStream2.vue"),
    // meta: {
    //   pageTitle: 'دوره ها',
    //   contentClass: 'ecommerce-application',
    //   breadcrumb: [
    //     {
    //       text: 'محصولات',
    //     },
    //     {
    //       text: 'لیست دوره ها',
    //     },
    //     {
    //       text: 'ویرایش',
    //       active: true,
    //     },
    //   ],
    // },
  },
  {
    path: "/apps/e-commerce/categories",
    name: "apps-e-commerce-categories",
    component: () =>
      import("@/views/apps/e-commerce/categories/categories-list.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
      contentClass: "ecommerce-application",
    },
  },
  {
    path: "/apps/e-commerce/courses/categories",
    name: "apps-e-commerce-courses-categories",
    component: () =>
      import("@/views/apps/e-commerce/courses/CourseCategories.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
      contentClass: "ecommerce-application",
    },
  },
  {
    path: "/apps/e-commerce/categories/edit/:id",
    name: "apps-e-commerce-categories-edit",
    component: () =>
      import("@/views/apps/e-commerce/categories/categories-edit.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
      contentClass: "ecommerce-application",
    },
  },
  {
    path: "/apps/e-commerce/:id",
    name: "apps-e-commerce-product-details",
    component: () =>
      import(
        "@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue"
      ),
    meta: {
      // pageTitle: 'اطلاعات محصول',
      contentClass: "ecommerce-application",
      resource: "ProductManager",
      action: "ProductManager",
      // breadcrumb: [
      //   {
      //     text: 'محصولات',
      //   },
      //   {
      //     text: 'لیست',
      //   },
      //   {
      //     text: 'ویرایش',
      //     active: true,
      //   },
      // ],
    },
  },
  //  Coupons
  {
    path: "/apps/coupons/list",
    name: "apps-coupons-list",
    component: () => import("@/views/apps/coupon/CouponList.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
    },
  },
  {
    path: "/apps/coupon/add",
    name: "apps-coupon-add",
    component: () => import("@/views/apps/coupon/CouponAdd.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
    },
  },
  {
    path: "/apps/coupon/edit/:id",
    name: "apps-coupon-edit",
    component: () => import("@/views/apps/coupon/CouponEdit.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
    },
  },
  {
    path: "/apps/coupon/used/:id",
    name: "apps-coupon-used",
    component: () => import("@/views/apps/coupon/CouponUsed.vue"),
    meta: {
      resource: "ProductManager",
      action: "ProductManager",
    },
  },

  //  Posts
  {
    path: "/apps/post/list",
    name: "apps-post-list",
    component: () => import("@/views/apps/post/PostList.vue"),
  },
  {
    path: "/apps/post/add",
    name: "apps-post-add",
    component: () => import("@/views/apps/post/PostAdd.vue"),
  },
  {
    path: "/apps/post/edit/:id",
    name: "apps-post-edit",
    component: () => import("@/views/apps/post/PostEdit.vue"),
  },

  //  Stories
  {
    path: "/apps/stories/add",
    name: "apps-stories-add",
    component: () => import("@/views/apps/stories/StoriesAdd.vue"),
  },
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: "/apps/admins",
    name: "apps-admins",
    component: () => import("@/views/apps/admins/admins.vue"),
  },
  {
    path: "/apps/users/list",
    name: "apps-users-list",
    component: () => import("@/views/apps/user/users-list/UsersList.vue"),
  },
  {
    path: "/apps/users/view/:id",
    name: "apps-users-view",
    component: () => import("@/views/apps/user/users-view/UsersView.vue"),
  },
  {
    path: "/apps/users/edit/:id",
    name: "apps-users-edit",
    component: () => import("@/views/apps/user/users-edit/UsersEdit.vue"),
  },
  {
    path: "/apps/faq-category/list",
    name: "apps-faq-category",
    component: () => import("@/views/faq-category/FaqCategoryList.vue"),
  },
  {
    path: "/apps/faq/create",
    name: "apps-faq-create",
    component: () => import("@/views/faq/FaqCreate.vue"),
  },
  {
    path: "/apps/faq/list",
    name: "apps-faq-list",
    component: () => import("@/views/faq/FaqList.vue"),
  },
  {
    path: "/apps/faq/:id",
    name: "apps-faq-edit",
    component: () => import("@/views/faq/FaqUpdate.vue"),
  },

  //  Financial

  {
    path: "/apps/financial/wallets/list",
    name: "apps-financial-wallets-list",
    component: () => import("@/views/apps/financial/wallets/WalletsList.vue"),
    meta: {
      resource: "Accountent",
      action: "Accountent",
    },
  },
  {
    path: "/apps/financial/wallets/info/:id",
    name: "apps-financial-wallets-info",
    component: () => import("@/views/apps/financial/wallets/WalletInfo.vue"),
    meta: {
      resource: "Accountent",
      action: "Accountent",
    },
  },
  {
    path: "/apps/financial/payments/list",
    name: "apps-financial-payments-list",
    component: () => import("@/views/apps/financial/payments/PaymentsList.vue"),
    meta: {
      resource: "Accountent",
      action: "Accountent",
    },
  },
  {
    path: "/apps/financial/payments/info/:id",
    name: "apps-financial-payments-info",
    component: () => import("@/views/apps/financial/payments/PaymentInfo.vue"),
    meta: {
      resource: "Accountent",
      action: "Accountent",
    },
  },
  {
    path: "/apps/orders/list",
    name: "apps-orders-list",
    component: () => import("@/views/apps/orders/OrdersList.vue"),
    meta: {
      resource: "Accountent",
      action: "Accountent",
    },
  },
  {
    path: "/apps/orders/info/:id",
    name: "apps-orders-info",
    component: () => import("@/views/apps/orders/OrderInfo.vue"),
    meta: {
      resource: "Accountent",
      action: "Accountent",
    },
  },

  // Invoice
  {
    path: "/apps/invoice/list",
    name: "apps-invoice-list",
    component: () =>
      import("@/views/apps/invoice/invoice-list/InvoiceList.vue"),
  },
  {
    path: "/apps/invoice/preview/:id",
    name: "apps-invoice-preview",
    component: () =>
      import("@/views/apps/invoice/invoice-preview/InvoicePreview.vue"),
  },
  {
    path: "/apps/invoice/add/",
    name: "apps-invoice-add",
    component: () => import("@/views/apps/invoice/invoice-add/InvoiceAdd.vue"),
  },
  {
    path: "/apps/invoice/edit/:id",
    name: "apps-invoice-edit",
    component: () =>
      import("@/views/apps/invoice/invoice-edit/InvoiceEdit.vue"),
  },
];
